import { TrendingUp, UserPlus, UserMinus, RotateCw, Star, ArrowRight } from 'lucide-react'
import LoopPage from '../../components/LoopPage'
import TrackedCTA from '../../components/TrackedCTA'

const stakeholders = [
  { icon: TrendingUp, label: 'Active customers', description: 'Where the relationship is right now. What is keeping them, and what is starting to wear thin.' },
  { icon: UserPlus, label: 'Onboarding cohort', description: 'The first 30 days. Where expectations diverged from reality. The cheapest place to fix churn.' },
  { icon: UserMinus, label: 'Churned customers', description: 'Why they left. Whether the trigger was your product, your service, or a moment in their business.' },
  { icon: RotateCw, label: 'Win-back candidates', description: 'The people who left but are still in your reach. What it would take to come back.' },
  { icon: Star, label: 'Champions', description: 'The people who refer you. Capture the language they use to describe what you do.' },
]

export default function CustomerLoop() {
  return (
    <div>
      <LoopPage
        h1="Acquire. Serve. Retain. Win them back."
        subhead="One loop across the full customer lifecycle. NPS that explains. Churn diagnostics that arrive in time. Onboarding that closes its own gaps."
        outerLoopSteps={['Acquire', 'Onboard', 'Serve', 'Retain', 'Win-back']}
        gapHeadline="NPS scores you. It doesn't explain you."
        gapBody="NPS gives you a number. Churn surveys come too late. The customer who saved another customer never gets asked. PrismScope closes every loop in the lifecycle — onboarding, NPS follow-up, churn diagnostic, win-back — with conversations that adapt to every answer."
        stakeholders={stakeholders}
        sampleRetro={{
          wentWell: 'NPS detractor follow-ups surfaced the real friction. Onboarding cohort completed step 3 at 78%.',
          couldHaveBeenBetter: 'Renewal-window outreach hit two weeks late. Win-back open rate below 10%.',
          whatsNext: 'Move renewal outreach to T-60 instead of T-30. Test win-back copy in champion language from the NPS loop.',
        }}
        trackingPrefix="customer-loop"
        seoTitle="Customer Feedback, NPS Follow-Up & Churn Research"
        seoDescription="One loop across the full customer lifecycle — NPS that explains itself, churn diagnostics that arrive in time, onboarding and win-back conversations."
        seoPath="/feedback-loops/customer"
      />
      <section className="bg-white py-16 md:py-24 border-t border-intelligence-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-intelligence-900 mb-4">
            Deep-dive: Churn Research
          </h2>
          <p className="text-lg text-intelligence-600 mb-8 max-w-2xl mx-auto">
            Three approaches, one goal: understand why customers leave.
          </p>
          <TrackedCTA
            href="/feedback-loops/customer/churn"
            location="customer-loop-churn-link"
            ctaName="Explore churn research"
            className="inline-flex items-center text-primary-600 font-medium hover:text-primary-700"
          >
            Explore churn research <ArrowRight className="ml-1 w-4 h-4" />
          </TrackedCTA>
        </div>
      </section>
    </div>
  )
}
